export default "__VITE_ASSET__DAGoPs1h__"